import { IPDropdown } from 'baseComponents/Dropdown/IPDropdown';
import { IPSelectableOption } from 'baseComponents/Utils/SelectableOption';
import { useTranslation } from 'react-i18next';

export interface INormOption {
  normId: number;
  name: string;
  // a standard the user may not see, or one that is no longer linked: shown, never dropped
  disabled?: boolean;
}

interface INormMultiSelectDropdownProps {
  label?: string;
  info?: string;
  options: INormOption[];
  selectedNormIds: number[];
  onChange: (normIds: number[]) => void;
  disabled?: boolean;
  errorMessage?: string;
  placeholder?: string;
}

// The multi-select dropdown over standards, keyed on the norm id, with a summary title: the collapsed
// dropdown otherwise shows only the first selected name and hides how many others are ticked.
const NormMultiSelectDropdown = (props: INormMultiSelectDropdownProps) => {
  const { t } = useTranslation(['translation']);

  const options: IPSelectableOption[] = props.options.map((option) => ({
    key: option.normId,
    text: option.name,
    disabled: option.disabled,
  }));

  const selectedNames = props.options
    .filter((option) => props.selectedNormIds.includes(option.normId))
    .map((option) => option.name);

  const title =
    selectedNames.length > 1
      ? t('translation:Norm.SelectedCount', { count: selectedNames.length })
      : selectedNames[0] ?? props.placeholder;

  const onChange = (_event: React.FormEvent<HTMLDivElement>, option?: IPSelectableOption) => {
    if (!option) return;
    const normId = Number(option.key);
    const next = option.selected
      ? [...props.selectedNormIds.filter((id) => id !== normId), normId]
      : props.selectedNormIds.filter((id) => id !== normId);
    props.onChange(next);
  };

  return (
    <IPDropdown
      label={props.label}
      info={props.info}
      multiSelect
      options={options}
      selectedKeys={props.selectedNormIds}
      disabled={props.disabled}
      errorMessage={props.errorMessage}
      placeholder={props.placeholder}
      title={title}
      onChange={onChange}
      styles={{ listbox: { maxHeight: 350 } }}
    />
  );
};

export default NormMultiSelectDropdown;
